import { accessToken } from '../../configuration/tokenHandling/accessToken';

export const prepareHeaders = (headers: Headers) => {
    const token = accessToken.getAccessToken();
    if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('Content-Type', 'application/json');
    }
    return headers;
};

export const responseHandler = async (response: Response) => {
    if (response.ok) {
        if (response.status === 204) {
            return;
        }
        try {
            return await response.json();
        } catch (error) {
            throw new Error(`${response.status} Invalid payload: ${error}`);
        }
    }
    if (response.status === 401) {
        throw new Error(`${response.status} Unauthorized: ${response.statusText}`);
    }
    throw new Error(`${response.status} Backend error: ${response.statusText}`);
};

export const urlEncodeIfNecessary = (url: string) => {
    try {
        return decodeURIComponent(url) === url ? encodeURIComponent(url) : url;
    } catch {
        return encodeURIComponent(url);
    }
};

export const RIO_AUDIT_LOG_HEADER = 'x-rio-audit-reason';
